<template>
  <v-snackbar
    auto-height
    v-model="snackbar"
    :bottom="y === 'bottom'"
    :left="x === 'left'"
    :right="x === 'right'"
    :timeout="timeout"
    :top="y === 'top'"
    :color="color"
  >
    <div>
      <b>{{ message.title }}</b>

      <br v-if="message.messages" />

      <div v-if="message.messages">
        <div v-for="(msg, index) in message.messages" :key="index">{{ msg }}</div>
      </div>
    </div>

    <v-spacer></v-spacer>

    <v-btn dark flat fab @click="hideNotification">
      <v-badge right light color="white" :value="countMessages>0">
        <template v-slot:badge>
          <span class="black--text">{{ countMessages }}</span>
        </template>

        <v-icon>mdi-close</v-icon>
      </v-badge>
    </v-btn>
  </v-snackbar>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

// @vuese
// Informacje ze zdarzeń
// @group MainLayout
export default {
  props: {
    // pozycja x
    x: {
      type: String,
      default: null
    },
    // pozycja y
    y: {
      type: String,
      default: 'top'
    },
    // czas wyświetlania, w ms
    timeout: {
      type: Number,
      default: 3000
    }
  },
  data() {
    return {
      snackbar: false
    };
  },
  methods: {
    // @vuese
    // Metoda zamykająca okienko ze zdarzeniem
    hideNotification() {
      this.$store.dispatch('hideNotification');
    }
  },
  computed: {
    ...mapState({
      show: state => state.notification.show,
      message: state => state.notification.current.message,
      color: state => state.notification.current.color
    }),
    ...mapGetters(['countMessages'])
  },
  watch: {
    show(val) {
      if (val) {
        this.snackbar = val;
      }
    },
    snackbar(val) {
      if (!val) {
        this.hideNotification();
      }
    }
  }
};
</script>